// extracted by mini-css-extract-plugin
module.exports = {"book_box":"book_box-2d0Gg4oz","book_list":"book_list-1Dl8JG85 clearfix","listl":"listl-33N5deeq","listr":"listr-2RZAw5CB"};